const ARS_FORMATTER = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' });

/** `unitPriceCents` is integer cents; e.g. `150000` → "$ 1.500,00". Same convention as `menus/format-base-price.ts`. */
export function formatPriceCents(cents: number): string {
  return ARS_FORMATTER.format(cents / 100);
}
